import type { CurriedComponent, CurriedHelper, CurriedModifier } from '@glimmer/interfaces';

export const CURRIED_COMPONENT = 0 satisfies CurriedComponent;
export const CURRIED_HELPER = 1 satisfies CurriedHelper;
export const CURRIED_MODIFIER = 2 satisfies CurriedModifier;
